import React from "react";
import Kyruus from "src/static/images/kyruus-icon.png";

const KyruusIcon = () => <img width={48} height={48} src={Kyruus} alt="kyruus-icon" />;

export default KyruusIcon;
